import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <footer className="copy-r">
        <p>
          Copyright ©True Corporation Public Company Limited All rights
          reserved.
        </p>
      </footer>
    );
  }
}
